// Adds the "AI generated" badge to images embedded in article rich-text content.
// Unlike theme-rendered images (snippets/img.liquid), these come from the article's
// HTML body field, so the badge can't be injected server-side per-image and has to be
// wired up here instead, using the same alt-text convention: alt ending in "AI generated."
(function () {
  var SUFFIX = 'AI generated.';

  function processContainer(container) {
    var badgeSrc = container.dataset.aiBadgeSrc;
    var badgeAlt = container.dataset.aiBadgeAlt;
    if (!badgeSrc) return;

    container.querySelectorAll('img:not([data-ai-badge-checked])').forEach(function (img) {
      img.dataset.aiBadgeChecked = 'true';

      var alt = img.getAttribute('alt') || '';
      if (alt.slice(-SUFFIX.length) !== SUFFIX) return;

      img.setAttribute('alt', alt.split(SUFFIX).join('').trim());

      var wrap = document.createElement('span');
      wrap.className = 'ai-badge-wrap';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);

      var badge = document.createElement('img');
      badge.className = 'ai-generated-badge ai-generated-badge--bottom-right';
      badge.src = badgeSrc;
      badge.alt = badgeAlt || '';
      badge.width = 48;
      badge.height = 48;
      badge.loading = 'lazy';
      wrap.appendChild(badge);
    });
  }

  function scan() {
    document.querySelectorAll('[data-ai-badge-src]').forEach(processContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
